import { render, staticRenderFns } from "./TermsConditionsCard.vue?vue&type=template&id=29fcac93&scoped=true&"
import script from "./TermsConditionsCard.vue?vue&type=script&lang=js&"
export * from "./TermsConditionsCard.vue?vue&type=script&lang=js&"
import style0 from "./TermsConditionsCard.vue?vue&type=style&index=0&id=29fcac93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fcac93",
  null
  
)

export default component.exports